import dynamic from "next/dynamic";

const Desktop = dynamic ( () => import ( "./desktop" ) );
const Mobile  = dynamic ( () => import ( "./mobile" ) );

const HomePage = props => {
	const {
		isMobile
	} = props;

	if ( isMobile )
		return (
			<Mobile { ...props } />
		);

	return (
		<Desktop { ...props } />
	);

};

export default HomePage;
